import { decodeEntities } from "./Misc";
import { htmlToDom } from "../shoutui/utils";
import { Constants } from "../model/Constants";

export default class Aria {
    $app: any;

    opensNewWindow: { text: any; img: string; };

    richAriaTypeToTextMap: { QuickReplyButton: any; CardDeck: any; };

    constructor(app) {
        this.$app = app;
        const ariaStrings = this.$app.ariaStrings || {};

        this.opensNewWindow = {
            text: ariaStrings.opensNewWindow,
            img: "external_link.png",
        };

        const tConfig = this.$app.getUIConfig().transcriptConfig || {};

        if (tConfig.opensNewWindowImageConfig) {
            this.opensNewWindow.img = tConfig.opensNewWindowImageConfig.imgName;
        }

        /**
         * @type {Object.<string, string>} - map of rich engine element type
         * to proper aria string
         */
        this.richAriaTypeToTextMap = {
            QuickReplyButton: this.$app.ariaStrings.quickReplyReader,
            CardDeck: this.$app.ariaStrings.cardDeckReader,
        };
    }

    /**
     * General function that scan's a string for missing
     * ARIA implementation patterns and inject's the proper aria attributes or elements.
     *
     * @param {string} ariaString - The target ARIA string
     * @returns {string} - String with injected attributes / elements
     */
    injectAttributes(ariaString) {
        // Check for html links with target
        ariaString = this.htmlTargetLinksInjectLabelAndIcon(ariaString);
        return ariaString;
    }

    /**
     * Checks the given string for html link tags with
     * target='_blank' or target='_new' attributes.
     *
     * If found, add's a title attribute with extra 'opens in new window' message
     * and an external link icon. Will not append if already set.
     *
     * @param {string} htmlString - string containing html tags
     */
    htmlTargetLinksInjectLabelAndIcon(htmlString) {
        if (typeof (htmlString) !== "string" || htmlString.trim().length === 0) {
            return htmlString;
        }

        const dom = htmlToDom(decodeEntities(htmlString));
        const newWindowLinks = dom.querySelectorAll("a[target='_blank'], a[target='_new']");

        let didAppend = false;
        newWindowLinks.forEach((el, idx) => {
            const orgTitle = el.getAttribute("title");

            // Check we do not insert / write if not required.
            if (!orgTitle || orgTitle.indexOf(this.opensNewWindow.text) == -1) {
                el.setAttribute("title", (orgTitle ? (`${orgTitle} — `) : "") + this.opensNewWindow.text);
                const img = document.createElement("img");
                img.classList.add("opensNewWindow");
                img.src = this.$app.getImagePath() + this.opensNewWindow.img;
                img.alt = "external link";
                el.appendChild(img);
                didAppend = true;
            }
        });

        if (didAppend) {
            return dom.innerHTML;
        }

        return htmlString;
    }

    /**
     * Takes raw rich engine aria outputs and generates the proper text outputs
     * based on their properties.
     *
     * @param {Array.<Object>} richAriaOutputs - Array of Aria outputs from rich engine items
     * @returns {Array.<String>} - Raw text strings ready for aria live output.
     */
    formatRichAriaOutputsToTextList(richAriaOutputs) {
        const ariaTexts = [];

        for (const prop in richAriaOutputs) {
            if (richAriaOutputs.hasOwnProperty(prop)) {
                const item = richAriaOutputs[prop];

                if (item.text) {
                    if (item.type && item.length > 0) {
                        if (this.richAriaTypeToTextMap[item.type]) {
                            ariaTexts.push(this.richAriaTypeToTextMap[item.type].replace("{total}", item.length));
                        }
                    }

                    ariaTexts.push(item.text);
                }
            }
        }
        return ariaTexts;
    }

    announceRichDataMessage(richAriaOutputs) {
        const richAriaTextsList = this.formatRichAriaOutputsToTextList(richAriaOutputs);

        for (let i = 0; i < richAriaTextsList.length; i++) {
            this.$app.getStateMgr().setState({ ariaReaderSay: richAriaTextsList[i] }, true);
        }
    }

    announceBubbleText(messageText, name) {
        if (messageText) {
            let msg = messageText;

            if (msg !== "" && msg !== Constants.EA) {
                if (name) {
                    msg = `${name} — ${msg}`;
                }

                this.$app.getStateMgr().setState({ ariaReaderSay: msg });
            }
        }
    }
}
